import { render, staticRenderFns } from "./WorkflowHistorySidebar.vue?vue&type=template&id=50483b74&"
import script from "./WorkflowHistorySidebar.vue?vue&type=script&lang=js&"
export * from "./WorkflowHistorySidebar.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowHistorySidebar.vue?vue&type=style&index=0&id=50483b74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports